import { useContext } from 'react';
import { StorageContext } from 'src/context/StorageContext';

export function useStorage() {
  return useContext(StorageContext);
}
